export const ADDTOCART = "cart/addToCart";
export const REMOVEFROMCART = "cart/removeFromCart";
export const CARTINCREMENT = "cart/INCREMENT";
export const CARTDECREMENT = "cart/DECRMENT";
